import React from 'react';
import Data from './Data';

const BannerSidebar = (props) => {
  return <Data {...props} />;
};

export default BannerSidebar;
